<template>
    <section class="login-page">
        <form @submit.prevent="handleLogin" class="login-form">
            <div class="login-card card bg-light">
                <div class="card-body text-center">
                    <img :src="logo" alt="" class="login-logo" />
                    <h2 class="fw-bold mb-4 text-uppercase login-title">
                        Login
                    </h2>

                    <div class="form-outline form-white mb-3">
                        <input type="text" id="typeEmailX" class="form-control form-control-lg"
                            v-model="user.username" />
                        <label class="form-label" for="typeEmailX">Benutzername</label>
                    </div>

                    <div class="form-outline form-white mb-4">
                        <input type="password" id="typePasswordX" class="form-control form-control-lg"
                            v-model="user.password" />
                        <label class="form-label" for="typePasswordX">Passwort</label>
                    </div>

                    <button class="btn btn-outline-light btn-lg px-5 login-button" type="submit">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        Einloggen
                    </button>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import logo from '../assets/logo.png';
import User from '../../models/user';
import { useToast } from 'vue-toastification';
import { isMobileBuild } from '@/utils/platform';

export default {
    name: 'userLogin',
    data() {
        return {
            logo: logo,
            user: new User('', ''),
            loading: false,
            message: '',
            toast: useToast(),
        };
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
    },
    created() {
        if (this.loggedIn) {
            this.goAfterAuth();
        }
    },
    methods: {
        goAfterAuth() {
            if (isMobileBuild()) {
                this.$router.replace({ name: 'protokolerfassen' });
                return;
            }
            this.$router.push('/home');
        },
        handleLogin() {
            this.loading = true;
            if (this.user.username && this.user.password) {
                this.$store.dispatch('auth/login', this.user).then(
                    () => {
                        this.goAfterAuth();
                    },
                    (error) => {
                        this.loading = false;
                        this.message =
                            (error.response && error.response.data) ||
                            error.message ||
                            error.toString();
                        const disabled = error.response?.data?.error === 'account_disabled';
                        this.toast.error(
                            disabled
                                ? 'Dieses Konto ist deaktiviert.'
                                : 'Benutzername oder Passwort ist falsch!',
                            { timeout: disabled ? 3000 : 2000 },
                        );
                    },
                );
            } else {
                this.loading = false;
                this.toast.error('Benutzername oder Passwort leer!', {
                    timeout: 2000,
                });
            }
        },
    },
};
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    min-height: 100dvh;
    background-color: #264271;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: max(1.25rem, env(safe-area-inset-top, 0px)) 1.25rem max(1.25rem, env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;
}

.login-form {
    width: 100%;
    max-width: 28rem;
}

.login-card {
    border-radius: 1rem;
    width: 100%;
    color: #264271;
}

.card-body {
    padding: 2rem 1.75rem;
}

.login-title,
label,
.form-label,
.form-control {
    color: #264271;
}

.login-logo {
    width: 7rem;
    height: 7rem;
    margin-bottom: 1rem;
}

label {
    padding: 0.3rem;
}

.login-button {
    background-color: #264271;
    color: white;
    padding: 0.5rem 1.5rem;
}

.login-button:hover,
.login-button:focus,
.login-button:active {
    box-shadow: 0 0 5px 5px #315492;
    background-color: #315492;
    color: white;
    border-color: #315492;
}

@media (max-width: 768px) {
    .login-page {
        padding: max(1rem, env(safe-area-inset-top, 0px)) 1rem max(1rem, env(safe-area-inset-bottom, 0px));
        align-items: center;
    }

    .card-body {
        padding: 1.5rem 1.25rem;
    }

    .login-logo {
        width: 5.5rem;
        height: 5.5rem;
        margin-bottom: 0.75rem;
    }

    .form-control-lg {
        font-size: 1rem;
        padding: 0.65rem 0.85rem;
    }
}
</style>
